/*********************************************************************************************************************
 * @file Tag reducers
 * @author Thomas Gantt <tg14@licorice.io>
 * @since 2.6.0
 * @date 10-Apr-2025
 *********************************************************************************************************************/
import { uri, GET } from '../../../constants.js';
import {
    setTags
} from '../../../redux/actions/index.js';
import { ezRedux, genericRequest } from '../../../redux/reducerUtil.js';
import { abstractedCreateAuthRequest } from '../../../services/util/baseRequests.js';
import { __ } from '../../../utils/i18n.jsx';

/**
 * @typedef {object} TagState
 * @property {array} tags
 */

/**
  * @type {TagState}
  */
const initialState = Object.freeze({
    tags:                          [],
    fieldError:                     '',
});

const getTagState = state => state.tag;

// requests

const getTags = () => genericRequest({}, abstractedCreateAuthRequest( GET, uri.GET_TAGS ), setTags, [ ], 
    { 
        tagType:           ['jobType', 'jobSubType', 'jobItem'],
        fields:            [ 'tag.tagName' ]
    }
);

const reducers = {
    [ setTags ]:               ( draft, payload ) => draft.tags = payload,
};

export {
    getTagState,
    getTags
};

export default ezRedux( reducers, initialState );